import React from 'react'

import { CloseIcon } from '@icons/CloseIcon'

import { Heading6 } from '@ui/Typography'

import IconButton from '@global/iconButton/IconButton'

import { ModalDesktop } from './ModalDesktop'
import { ModalTitle } from './common/components/ModalTitle'
import { cloneButtonLarge, isButtonValid } from './common/helpers/button'
import type { CommonModalProps } from './types'

import styles from './BasicModal.module.scss'

interface BasicModalProps extends CommonModalProps {
  renderFooter?(props: BasicModalProps): React.ReactNode[]
  hasCloseButton?: boolean
}

// TODO: WARNING: This component is implemented only for "IB" and has design logic issues, be careful when you are using it! the "width" is hard-coded, we should use "size" property <Modal size="sm" />. The component requires major improvements, there is ui problems.
export const BasicModal: React.FC<BasicModalProps> = (props) => {
  const { title, onClose, renderFooter, children, hasCloseButton } = props

  return (
    <ModalDesktop onClose={onClose}>
      <div className={styles.basicModal}>
        <div className={styles.header}>
          <Heading6 medium>
            <ModalTitle title={title} />
          </Heading6>
          {hasCloseButton && (
            <IconButton.New appearance='secondary' onClick={onClose} className={styles.closeButton}>
              <CloseIcon />
            </IconButton.New>
          )}
        </div>
        {children}
        <footer className={styles.footer}>
          {renderFooter?.({ ...props, onClose }).map((button, index) => {
            return isButtonValid(button) ? (
              cloneButtonLarge(button)
            ) : (
              <span key={index}>{button}</span>
            )
          })}
        </footer>
      </div>
    </ModalDesktop>
  )
}
